import React from 'react';
import Container from '@mui/material/Container';
import './CompPageTemplateCommon.css'; // Assuming you have a CSS file for styling

function CompPageTemplateCommon({ children }) {
  return (
    <Container className="fullWidthContainer">
      {children}
    </Container>
  );
}

export default CompPageTemplateCommon;
